import { render, staticRenderFns } from "./POSForm.vue?vue&type=template&id=7810e994&scoped=true"
import script from "./POSForm.vue?vue&type=script&lang=js"
export * from "./POSForm.vue?vue&type=script&lang=js"
import style0 from "./POSForm.vue?vue&type=style&index=0&id=7810e994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810e994",
  null
  
)

export default component.exports